import apiService from "./apiService";
import AppConstants from "../appConstants";
import themeConfig from "../../themeConfig";
import convertDatetimeHelper from "../helpers/convert-datetime-helper";
import { CONTENT } from "../enums/enum-content";
import VueI18n from "../i18n/i18n";
import localStorageHelper from "../helpers/local-storage-helper";

class ReportService {

    getAllReportsByCommodity(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_LIST_REPORT_ALL, params)
                .then(response => {
                    response.data = response.data.map(item => {
                        if (item.newsContent[0].code == CONTENT.INFORMATIVE ||
                            item.newsContent[0].code == CONTENT.STATISTIC ||
                            item.newsContent[0].code == CONTENT.EXPORTS) {
                            item.reportDateFormat = convertDatetimeHelper.convertDateToStringFormatReport(item.dt_report);
                            item.data_object = convertDatetimeHelper.convertDateToStringFormatReport(item.dt_report);
                        } else {
                            item.reportDateFormat = convertDatetimeHelper.convertDateToStringFormatReport(item.dt_publish);
                            item.data_object = new Date(item.dt_publish);
                        }
                        return item;
                    });
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    }

    getCommodityConfigFilter(params, isDesktop) {
        if (localStorageHelper.getS4Login()) {
            params.append('s4System', true);
        }
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_COMMODITY_CONFIG_FILTER, params)
                .then(response => {
                    // [2023-05-17] pedido para habilitar cotação no mobile
                    // if (!isDesktop) {
                    //     response.quotes = [];
                    // }
                    response.analysis.unshift(AppConstants.INFORMATIVE_FILTER_ALL_OPTION);
                    if (themeConfig.client == AppConstants.PLATFORM_CLIENT.CMA) {
                        response.analysis.unshift({ isLabel: true, text: VueI18n.t('REPORT_FILTER').Information_label, habilitado: true });
                    } else if (themeConfig.client == AppConstants.PLATFORM_CLIENT.SAFRAS) {
                        if (isDesktop) {
                            response.analysis.unshift({ isLabel: true, text: VueI18n.t('REPORT_FILTER').Informative, habilitado: true });
                        }
                    }

                    // [2023-05-17] pedido para habilitar cotação no mobile
                    if (response.quotes.length > 0 && isDesktop) {
                        response.quotes.unshift({ isLabel: true, text: VueI18n.t('REPORT_FILTER').Follow_Market, habilitado: true });
                    }
                    if (response.favorites.length > 0 && isDesktop) {
                        response.favorites.unshift({ isLabel: true, text: VueI18n.t('REPORT_FILTER').Favorite_Content, habilitado: true });
                    }


                    resolve(response);
                })
                .catch(error => reject(error));
        });
    }

    getNewsDetail(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_NEWS_DETAIL}/${id}`, params)
                .then(response => {
                    response.reportDateFormat = convertDatetimeHelper.convertDateToStringFormatReport(response.dt_report ? response.dt_report : response.dt_publish)
                    response.data_object = new Date(response.dt_report ? response.dt_report : response.dt_publish);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    }
    getFilters(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CONTENT_FILTERS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getCommodityReportTypeFilter(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_COMMODITY_REPORT_TYPE_FILTER, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getElevenContentInList(contentList) {
        return contentList.filter(item => {
            if (item.id == CONTENT.ELEVEN_MACRO_BRASIL ||
                item.id == CONTENT.ELEVEN_ATIVIDADE ||
                item.id == CONTENT.ELEVEN_INFLACAO ||
                item.id == CONTENT.ELEVEN_POLITICA_MONETARIA ||
                item.id == CONTENT.ELEVEN_FOCUS ||
                item.id == CONTENT.ELEVEN_FISCAL ||
                item.id == CONTENT.ELEVEN_INTERNACIONAL ||
                item.id == CONTENT.ELEVEN_MERCADOS ||
                item.id == CONTENT.ELEVEN_CARTA_ESTRATEGISTA) {
                return item;
            }
        });
    }

    getMarketContentPositionInList(contentList) {
        return contentList.findIndex(item => {
            return item.id == CONTENT.PHYSICAL_MARKET || item.id == CONTENT.FUTURE_MARKET || item.id == CONTENT.INDICATIVE_MARKET || item.id == CONTENT.EXCHANGE_MARKET || item.id == CONTENT.ACTIVE_MARKET;
        });
    }

    getHedgeContentInList(contentList) {
        return contentList.filter(item => {
            if (item.id == CONTENT.HEDGE_CAMBIAL || item.id == CONTENT.HEDGE_COMMODITIES || item.id == CONTENT.HEDGE_WHATS) {
                return item;
            }
        });
    }

    removeHedgeContentInList(contentList) {
        return contentList.filter(item => {
            if (item.id != CONTENT.HEDGE_CAMBIAL && item.id != CONTENT.HEDGE_COMMODITIES && item.id != CONTENT.HEDGE_WHATS) {
                return item;
            }
        });
    }

    removeMarketContentInList(contentList) {
        return contentList.filter(item => {
            if (item.id != CONTENT.ACTIVE_MARKET &&
                item.id != CONTENT.EXCHANGE_MARKET &&
                item.id != CONTENT.INDICATIVE_MARKET &&
                item.id != CONTENT.PHYSICAL_MARKET &&
                item.id != CONTENT.FUTURE_MARKET) {
                return item;
            }
        });
    }

    removeElevenContentInList(contentList) {
        return contentList.filter(item => {
            if (item.id != CONTENT.ELEVEN_MACRO_BRASIL &&
                item.id != CONTENT.ELEVEN_ATIVIDADE &&
                item.id != CONTENT.ELEVEN_INFLACAO &&
                item.id != CONTENT.ELEVEN_POLITICA_MONETARIA &&
                item.id != CONTENT.ELEVEN_FOCUS &&
                item.id != CONTENT.ELEVEN_FISCAL &&
                item.id != CONTENT.ELEVEN_INTERNACIONAL &&
                item.id != CONTENT.ELEVEN_MERCADOS &&
                item.id != CONTENT.ELEVEN_CARTA_ESTRATEGISTA) {
                return item;
            }
        });
    }

    downloadReportFile(filename, params) {
        return new Promise((resolve, reject) => {
            apiService.downloadFile(filename, params)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    downloadPublicFile(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_DOWNLOAD_PUBLIC_FILE, params)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    readDocumentFile(id, params) {
        return new Promise((resolve, reject) => {
            apiService.readFile(`${AppConstants.URL_NEWS_READ_DOCUMENT}/${id}`, params)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    readDocumentFileWithUrl(url, params) {
        return new Promise((resolve, reject) => {
            apiService.readFile(url, params)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    downloadDocumentWatermarkFile(id, params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(`${AppConstants.URL_NEWS_DOWNLOAD_DOCUMENT_WATERMARK}/${id}`, params)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getRelatedNews(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_RELATED_NEWS, params)
                .then((response) => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    }

    sendReadNews(id, params) {
        return new Promise((resolve, reject) => {
            apiService.post(`${AppConstants.URL_SEND_READ_NEWS}/${id}`, {}, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getNewsTicker(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_TICKER, params)
                .then(response => {
                    response.data = response.data.map(item => {
                        item.reportDateFormat = convertDatetimeHelper.convertDateToStringFormatReport(item.dt_publish);
                        item.data_object = new Date(item.dt_publish);
                        return item;
                    });
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    }

    getListNewsById(body, params) {
        return new Promise((resolve, reject) => {
            apiService.post(`${AppConstants.URL_LIST_NEWS_DETAIL}`, body, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getAllQuotesContentList(params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_LIST_QUOTES_CONTENT_ALL}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

}

export default new ReportService();
